
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/libreros",
      function () {
        return require("private-next-pages/libreros/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/libreros"])
      });
    }
  